import Vue from 'vue'
import App from '@/App.vue'
import vuetify from '@/plugins/vuetify'
import API from '@/plugins/api'
import router from '@/plugins/router'
import i18n from '@/plugins/i18n'
import store from '@/plugins/store'
import { domain, clientId, audience } from "@/plugins/auth/config.json"
import { Auth0Plugin, getInstance } from "@/plugins/auth"
import FlagIcon from "vue-flag-icon";
import VueMask from 'v-mask'

import '@/styles/main.scss'
import '@/plugins/filters'

Vue.use(FlagIcon);
Vue.use(VueMask)

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl ?
        appState.targetUrl :
        window.location.pathname
    );
  }
})

Vue.config.productionTip = false

// Load API config immediately (no auth token yet) so endpointList is
// populated before any component renders and makes store actions.
console.log('[boot] API.init(null) start')
const configReady = API.init(null);

//- Create a watcher to get JWT token when authenticated
const instance = getInstance();
instance.$watch("loading", async loading => {
  console.log('[boot] Auth0 loading changed:', loading, '| isAuthenticated:', instance.isAuthenticated)

  if (!loading) {

    if (instance.isAuthenticated) {
      console.log('[boot] Authenticated – getting token')
      const token = await instance.getTokenSilently();
      // Set auth header and mark as authenticated immediately – no config needed
      API.setHeaders('Authorization', `Bearer ${token}`);
      store.dispatch('app/setAuthenticated', token);
      console.log('[boot] Token received – waiting for config if needed')
      await configReady;
      console.log('[boot] Config ready – dispatching setUserData')
      // Config is ready – now safe to call endpoints
      store.dispatch('app/setUserData', instance.user);
    } else {
      console.log('[boot] Not authenticated')
    }
  }
});

configReady.then(() => {
  console.log('[boot] API.init(null) done – mounting Vue app')
  new Vue({
    vuetify,
    router,
    i18n,
    store,
    render: h => h(App)
  }).$mount('#app')
})